import React from 'react';
import { wrapDisplayName } from 'recompose';
import _ from 'lodash';
import fp from 'lodash/fp';
import { withClient } from '@deerplusofficial/pos-hoc';
import { mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import actions from '../../actions';

const {
  submit: { enable: enableSubmitInvoice, disable: disableSubmitInvoice },
} = actions.invoice;

const getStatus = fp.get(['data', 'status']);

export default () => Component =>
  fp.compose(
    withClient(),
    connect(
      mapState(['receipt', 'invoice']),
      { enableSubmitInvoice, disableSubmitInvoice }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'withCreateInvoice');

      onInvoiceCreate = async ({ carrierId }) => {
        const {
          client: { POSApi, onError },
          receipt: { orderId },
          invoice: { vatId, submitting },
          enableSubmitInvoice,
          disableSubmitInvoice,
        } = this.props;

        if (submitting) return;

        try {
          enableSubmitInvoice();
          const status = getStatus(
            await POSApi.post(`/orders/${orderId}/invoices`, {
              vat_id: _.size(vatId) === 8 ? vatId : _.noop(),
              carrier_id: carrierId,
              carrier_type: _.size(carrierId) ? 0 : _.noop(),
            })
          );
          return { status };
        } catch (e) {
          onError(e);
        } finally {
          disableSubmitInvoice();
        }
      };

      render() {
        return (
          <Component {...this.props} onInvoiceCreate={this.onInvoiceCreate} />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCreateInvoice.js